<template>
    <div class="pl-5">
        <h1>Magento plugin</h1>
        <p style="font-style: italic; font-weight: bold;">NB! Magento plugin was updated on 2021-09-22 to new v2 version. Please update your plugin if you have older version of Magento plugin.</p>
        <p style="font-style: italic;">Magento plugin don't use cron anymore so if you have installed cron because of Tarkpay plugin then you can remove that dependency.</p>

        <p>
            Tarkpay offers a Payment plugin for Magento. This plugin is for Magento 2 and developed for version 2.4. Our
            payment plugin is developed only for EUR currency.<br />
            You can download the plugin:
            <a href="/static/magento-plugin/tarkpay-magento-payment-v2-4.zip">here</a>
        </p>
        <p>
            1. The first step is to upload the plugin to root-folder/app/code/ folder in your Magento installation. Then
            you have: root-folder/app/code/Tarkpay/PaymentGateway/...
        </p>
        <p>
            2. Navigate your command line to root folder and then run command: bin/magento setup:upgrade
        </p>
        <p>
            3. Run command bin/magento setup:di:compile
        </p>
        <p>
            4. Run command bin/magento cache:clean
        </p>
        <p>
            5. Under the Magento's settings, go to Stores->Configuration->Sales->Payment Methods.
        </p>
        <p>
            5.1 First, make sure that the TarkPay Payment Gateway payment method is enabled
        </p>
        <p>
            5.2 After making sure the method is enabled, you can choose if to use Tarkpay in Sandbox mode or LIVE
            enviornment.<br />
            Then fill in the necessary credentials (client ID and API key).
            <br />
            <img src="/static/img/magento-1.png" />
            <br />
            Then you can choose between showing banks or not. Showing banks will look like:
            <br />
            <img src="/static/img/magento-2.png" />
        </p>
    </div>
</template>

<script>
export default {
    name: "magento-plugin-page"
};
</script>

<style scoped></style>
